import React from 'react';
import BaseFloatingModal from './BaseFloatingModal';

const LinkSharedModal = ({ isOpen, onClose, resultMsg }) => {
  return (
    <BaseFloatingModal
      icon={
        <svg width='63' height='63' viewBox='0 0 63 63' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <circle cx='31.5' cy='31.5' r='30.5' fill='#FFE000' stroke='#6B6B6B' />
          <path
            d='M14 32C14 29.6131 14.9809 27.3239 16.727 25.6361C18.473 23.9482 20.8411 23 23.3103 23H29.4715V26.6H23.3103C21.8288 26.6 20.4079 27.1689 19.3603 28.1816C18.3127 29.1943 17.7241 30.5678 17.7241 32L17.7246 32.0671C17.7427 33.475 18.329 34.8215 19.3603 35.8184C20.4079 36.8311 21.8288 37.4 23.3103 37.4H29.5685V41H23.3103C20.8411 41 18.473 40.0518 16.727 38.3639C14.9809 36.6761 14 34.3869 14 32ZM46.2759 32C46.2759 30.5678 45.6873 29.1943 44.6397 28.1816C43.5921 27.1689 42.1712 26.6 40.6897 26.6H34.5285V23H40.6897C43.1589 23 45.527 23.9482 47.273 25.6361C49.0191 27.3239 50 29.6131 50 32C50 34.3869 49.0191 36.6761 47.273 38.3639C45.527 40.0518 43.1589 41 40.6897 41H34.4315V37.4H40.6897C42.1712 37.4 43.5921 36.8311 44.6397 35.8184C45.6873 34.8057 46.2759 33.4322 46.2759 32ZM40.7618 30.2V33.8H23.3934V30.2H40.7618Z'
            fill='#FF451A'
          />
        </svg>
      }
      boldText={resultMsg}
      subText='Ready to share with the world!'
      isOpen={isOpen}
      onClose={onClose}
    />
  );
};

export default LinkSharedModal;
